module.exports = __webpack_public_path__ + "02_hair_silver.a39e3422.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/02_hair_silver.png
// module id = 2IYk
// module chunks = 0